module.exports = __webpack_public_path__ + "img/c00_buildingtechnetlures_Normal_ua.2ec2605d.webp";